import useSourceFlowCollection from "../hooks/useSourceFlowCollection";
import data from "../.sourceflow/region.json";

export const useRegion = () => useSourceFlowCollection(data);

export default useRegion;
